'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:tower:commentCallback');
}

var _invoke = require('../invoke');

/**
 * 专题评论成功通知
 *
 * 专题评论成功后，通知客户端，无返回数据
 *
 * 支持版本
 * + iTower/0.4+
 *
 * @memberof tower
 * @static
 * @name sendTopicCommentSuccess
 * @return {Promise<string | err>}
 * @example
 *  hbnb.tower.commentCallback();
 */

module.exports = function(cb, eb) {
    return new Promise(function(resolve, reject) {
        _invoke('tower', 'sendTopicCommentSuccess', {
            callback: function(result) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('comment callback result is %j', result, result);
                }
                resolve(result);
            },
            errback: reject
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/tower/comment-callback.js
// module id = 283
// module chunks = 4